import { render, staticRenderFns } from "./ManagePayBoxList.vue?vue&type=template&id=6b3b8056&scoped=true&"
import script from "./ManagePayBoxList.vue?vue&type=script&lang=js&"
export * from "./ManagePayBoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3b8056')) {
      api.createRecord('6b3b8056', component.options)
    } else {
      api.reload('6b3b8056', component.options)
    }
    module.hot.accept("./ManagePayBoxList.vue?vue&type=template&id=6b3b8056&scoped=true&", function () {
      api.rerender('6b3b8056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/manage-pay-box/ManagePayBoxList.vue"
export default component.exports